import 'css-chunksrc/client/scenes/resourceSecondaryCriteria/styles.scss';export default {
  "secondaryCriteria": "_secondaryCriteria_rzlcu_1",
  "row": "_row_rzlcu_9",
  "label": "_label_rzlcu_14",
  "form": "_form_rzlcu_25"
};